module.exports = __webpack_public_path__ + "static/media/garvinpic.00c38454.gif";